export default __webpack_public_path__ + "static/media/main.d194c3fb.gif";